var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-sns-tweet-box"},[_c('a',{staticClass:"twitter-timeline",attrs:{"href":_vm.twitterPath,"width":"100%","height":"100%"}},[_vm._v("Tweets by "+_vm._s(_vm.twitterId))])])}
var staticRenderFns = []

export { render, staticRenderFns }